import {Component, forwardRef, Injector, Input, OnChanges, SimpleChanges} from "@angular/core";
import {ColumnComponent} from "../../../framework/entity/grid/column.component";
import {
    AbstractSingleSelectColumnComponent
} from "../../../framework/entity/edit/edit-grid/columns/abstract-single-select-column.component";

@Component({
    selector: "wbo-measure-single-select-column",
    templateUrl: "./measure-single-select-column.component.html",
    providers: [
        {provide: ColumnComponent, useExisting: forwardRef(() => MeasureSingleSelectColumnComponent), multi: true}
    ]
})
export class MeasureSingleSelectColumnComponent extends AbstractSingleSelectColumnComponent implements OnChanges {
    @Input() convertToRequired: boolean;
    @Input() inventoryMeasureIdentifier: number;
    @Input() extendedSearchComponentParams: any;
    @Input() extendedEditComponentParams: any;

    constructor(injector: Injector) {
        super(injector);
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.valueField = this.field + "." + "measureId";
        this.labelField = this.field + ".symbol";
    }
}
